import React, { createContext, type PropsWithChildren, useContext, useMemo, useState } from 'react';

export enum MintReferralType {
  Playlist = 'playlist',
  Post = 'post',
}

interface PlaylistReferralContext {
  referralData: {
    playlistId: string;
    playlistUserAddress: string;
  };
  referralType: MintReferralType.Playlist;
}

interface PostReferralContext {
  referralData: {
    postId: string;
    postUserAddress: string;
  };
  referralType: MintReferralType.Post;
}

export type MintReferral = PlaylistReferralContext | PostReferralContext | null;

interface IMintReferralContext {
  setReferral: (referral: MintReferral) => void;
  referral: MintReferral;
}

const MintReferralContext = createContext<IMintReferralContext>({
  setReferral: () => undefined,
  referral: null,
});

export const useMintReferral = () => {
  return useContext(MintReferralContext);
};

export const MintReferralProvider = ({ children }: PropsWithChildren) => {
  const [referral, setReferral] = useState<MintReferral | null>(null);
  const value = useMemo(() => {
    return { referral, setReferral };
  }, [referral, setReferral]);
  return <MintReferralContext.Provider value={value}>{children}</MintReferralContext.Provider>;
};
